export default "__VITE_ASSET__OaZaIKb___"